import $ from 'jquery';
import 'slick-carousel';

export function initControlsSlider(isMobile) {
  const slider = document.querySelector(`#events-controls-slider`);

  $(slider).slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    useCSS: false
  });
}

export function initModalSlider() {

}
